var _circle, _path, _path2, _path3, _line, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoalMix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9995,
    r: 2.13333,
    fill: "#D91F05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C16.336 1 16.6695 1.01105 17 1.0328V0.030742C16.6693 0.0103478 16.3358 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16H31Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.37925C16.6708 5.34865 16.3373 5.33301 16.0002 5.33301C10.1091 5.33301 5.3335 10.1086 5.3335 15.9997C5.3335 21.8907 10.1091 26.6663 16.0002 26.6663C21.8911 26.6663 26.6667 21.8909 26.6668 16H25.6668C25.6667 21.3386 21.3388 25.6663 16.0002 25.6663C10.6614 25.6663 6.3335 21.3384 6.3335 15.9997C6.3335 10.6609 10.6614 6.33301 16.0002 6.33301C16.3378 6.33301 16.6713 6.35031 17 6.38409V5.37925Z",
    fill: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9.67726C16.6742 9.62615 16.3402 9.59961 16.0001 9.59961C12.4655 9.59961 9.6001 12.465 9.6001 15.9996C9.6001 19.5342 12.4655 22.3996 16.0001 22.3996C19.5346 22.3996 22.3999 19.5344 22.4001 16H21.4001C21.3999 18.9822 18.9823 21.3996 16.0001 21.3996C13.0178 21.3996 10.6001 18.9819 10.6001 15.9996C10.6001 13.0173 13.0178 10.5996 16.0001 10.5996C16.3417 10.5996 16.676 10.6313 17 10.692V9.67726Z",
    fill: "#D91F05"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.4592,
    y1: 16.4915,
    x2: 26.5275,
    y2: 6.24215,
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 4.26641V6.93307H28.2666L31.4666 4.26641H28.2666V1.06641L25.6 4.26641Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalMix);
export default __webpack_public_path__ + "static/media/goal_mix.60e977d790184e5c6c575292bbd7815e.svg";
export { ForwardRef as ReactComponent };